module.exports = __webpack_public_path__ + "img/showImg-2.061e787f.jpg";